module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_review_help.57cc29ce.svg";